import React from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom"

import { PrivateRoute, AuthRoute, ScrollTop } from "@components";
import {
  LoginScreen,
  RegisterCompanyScreen, 
  RegisterCandidateScreen,
  ForgotPasswordScreen,
  SearchScreen,
  ProfilScreen, 
  EditProfil, 
  ResetPassword, 
  Favourites,
  NotMatch,
  OffersScreen,
  OfferDetailsScreen,
  PersonDetails,
  FavoriteOffersScreen,
  CandidateProfileScreen,
  AnnonceScreen,
  AddAnnonce, AnnonceDetails, EditAnnonce, 
  // PurchaseAnnonce,
  // Purchase, 
  ResetPasswordCandidateScreen, EditProfileCandidateScreen,
  LandingScreen,
  SearchHome, OffersHome
} from "@pages";

const Routing = () => {

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <ScrollTop />
      <Switch>
        {/* Global routes */}
        <Redirect from="/" to="/login" exact />
        <AuthRoute path="/login" exact component={LoginScreen} />
        <AuthRoute path="/forgot-password" component={ForgotPasswordScreen} />

        {/* LandingScreen */}
        <Route path="/test" component={LandingScreen} />

        {/* Company's routes */}
        <AuthRoute path="/company/register" component={RegisterCompanyScreen} />
        {/* Search candidate */}
        <Redirect from="/company" to="/company/home" exact />
        <PrivateRoute type="company" path="/company/home" component={SearchHome} />
        <PrivateRoute type="company" exact path="/company/search" component={SearchScreen} />
        {/* Profile */}
        <PrivateRoute type="company" exact path="/company/profile" component={ProfilScreen} />
        <PrivateRoute type="company" path="/company/profile/edit-profile" component={EditProfil} />
        <PrivateRoute type="company" path="/company/profile/reset-password" component={ResetPassword} />
        {/* <PrivateRoute type="company" path="/company/profile/purchase" component={Purchase} /> */}
        {/* CV candidate details */}
        <PrivateRoute type="company" path="/company/search/person/:id" component={PersonDetails} />

        {/* Favourite Candidates */}
        <PrivateRoute type="company" path="/company/favourite" component={Favourites} />
        {/* Annonce */}
        <PrivateRoute type="company" exact path="/company/annonce" component={AnnonceScreen} /> 
        <PrivateRoute type="company" path="/company/annonce/add" component={AddAnnonce} />
        <PrivateRoute type="company" path="/company/annonce/details/:id" component={AnnonceDetails} />
        <PrivateRoute type="company" path="/company/annonce/:type/:id" component={EditAnnonce} />  
        {/* <PrivateRoute type="company" path="/company/annonce/purchase" component={PurchaseAnnonce} />          */}
  
        {/* Candidate's routes */}
        <AuthRoute path="/candidate/register" component={RegisterCandidateScreen} />
        {/* Search offers */}
        <Redirect from="/candidate" to="/candidate/home" exact />
        <PrivateRoute type="person" path="/candidate/home" component={OffersHome} />
        <PrivateRoute type="person" path="/candidate/offers" component={OffersScreen} exact />
        <PrivateRoute type="person" path="/candidate/offers/:id" component={OfferDetailsScreen} />
        <PrivateRoute type="person" path="/candidate/favorite" component={FavoriteOffersScreen} />
        <PrivateRoute type="person" exact path="/candidate/profile" component={CandidateProfileScreen} />
        <PrivateRoute type="person" path="/candidate/profile/edit-profile" component={EditProfileCandidateScreen} />
        <PrivateRoute type="person" path="/candidate/profile/reset-password" component={ResetPasswordCandidateScreen} />

        <Route path="*" component={NotMatch}/>
      </Switch>
    </Router>
  );
}

export default Routing;
